


































































































































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import DocumentApiHead from '@/data/DocumentApiData';
import AuthModule from '@/store/modules/Auth';
import { getModule } from 'vuex-module-decorators';
import DocumentModule from '@/store/modules/Document';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class TransferKey extends Mixins(ErrorHandleMixin) {
  DocumentInstance = getModule(DocumentModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  TableHead: any = {};

  modalAddDocument = false

  data = []

  provider = ''

  docSeamless = ''

  docTransfer = ''

  assetGame = ''

  editStatus = false

  isOpenRemove = false;

  currentSelection: any = {};

  providername = ''

  created() {
    this.fetchDocumentApi();
    if (['SUBCOMPANY', 'SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)) {
      this.TableHead[0] = [...DocumentApiHead.TableHead[0]];
    } else {
      this.TableHead[0] = [...DocumentApiHead.TableHead[0]]
        .filter((item: any) => !item.isHidden);
    }
  }

  async fetchDocumentApi() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.DocumentInstance.FetchDocumentApi();
    this.data = this.DocumentInstance.documentApi;
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.modalAddDocument = false;
  }

  createURL() {
    this.modalAddDocument = true;
    this.editStatus = false;
    this.provider = '';
    this.docSeamless = '';
    this.docTransfer = '';
    this.assetGame = '';
  }

  async createUrl() {
    this.GeneralInstance.toggleLoading(true);
    const createUrl = {
      provider: this.provider,
      urlDocSeamless: this.docSeamless,
      urlDocTransfer: this.docTransfer,
      urlAssetGame: this.assetGame,
    };
    const res = await this.DocumentInstance.CreateDocumentApi(createUrl);
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.modalAddDocument = false;
    this.fetchDocumentApi();
  }

  async download(data) {
    if (data.indexOf('http://') === 0 || data.indexOf('https://') === 0) {
      window.open(`${data}`);
    } else {
      window.open(`http://${data}`);
    }
  }

  editURL(data) {
    this.editStatus = true;
    this.modalAddDocument = true;
    this.provider = data.provider;
    this.docSeamless = data.link.seamless;
    this.docTransfer = data.link.transfer;
    this.assetGame = data.link.asset;
  }

  remove(item) {
    this.providername = item.provider;
    this.currentSelection = item;
    this.isOpenRemove = true;
  }

  async submitRemove() {
    const res = await this.DocumentInstance.DeleteDocumentApi({
      _id: this.currentSelection._id,
    });
    this.checkError(res);
    this.isOpenRemove = false;
    this.fetchDocumentApi();
  }
}
